<div class="flex items-center px-2 py-1 gap-2 bg-indigo-500	rounded-full">
    <mat-icon class="text-white">{{ icon }}</mat-icon>
    <span class="min-w-4 font-medium text-sm text-white">
        {{ content }}
    </span>
</div>